import type { InjectionKey } from 'vue';
import { ApiService } from './api-service';

export const API_SYMBOL: InjectionKey<ApiService> = Symbol(__DEV__ ? 'API' : '');
